// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","771":"component---src-pages-page-2-js"}[chunkId] + "-" + {"125":"b11aba5005ea8ec9a997","293":"00815214d51a98c9193d","771":"cef561fb3e7c522e7a88"}[chunkId] + ".js";
};